module.exports = __webpack_public_path__ + "img/TM.3d9a73e5.svg";